/* eslint-disable @next/next/no-img-element */
import { ArrowLeft } from 'lucide-react'
import Link from 'next/link'

import { ForgotPasswordForm } from '@/components/forms/auth/forgot-password-form'

import { NON_FSDS_DEFAULT_LOGO_URL } from '@/configs/non-fsds-config'
import { TEMPLATE_DEFAULT_URLS } from '@/configs/template-default-urls'

export interface NonFsdsForgotPasswordSectionProps {
  title: string
  subtitle: string
  logoUrl: string
  backLinkText: string
  brandHref?: string
  signInUrl?: string
}

export default function NonFsdsForgotPasswordSection({
  title = 'Forgot Password',
  subtitle = "No worries, we'll send you reset instructions.",
  logoUrl = NON_FSDS_DEFAULT_LOGO_URL,
  backLinkText = 'Back to sign in',
  brandHref = TEMPLATE_DEFAULT_URLS.home,
  signInUrl = TEMPLATE_DEFAULT_URLS.signIn,
}: NonFsdsForgotPasswordSectionProps) {
  return (
    <div className="min-h-svh flex flex-col items-center justify-center bg-slate-50 py-12 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-full opacity-40 bg-[radial-gradient(circle_at_top_left,_var(--tw-gradient-stops))] from-blue-100 via-transparent to-transparent pointer-events-none" />
      <div className="absolute -bottom-24 -right-24 w-96 h-96 rounded-full bg-blue-500/10 blur-3xl pointer-events-none" />
      <div className="absolute top-20 left-10 w-72 h-72 rounded-full bg-blue-300/10 blur-3xl pointer-events-none" />

      <div className="w-full max-w-md bg-white rounded-3xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] sm:p-12 p-8 relative z-10 border border-slate-100/50">
        <div className="mb-8 flex justify-center">
          <Link href={brandHref} className="inline-block transition-transform hover:scale-105 active:scale-95 duration-200">
            <img src={logoUrl} alt="Logo" className="h-10 w-auto" />
          </Link>
        </div>

        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-slate-900 mb-2">{title}</h2>
          <p className="text-sm text-slate-500 max-w-sm mx-auto">{subtitle}</p>
        </div>

        <div className="w-full">
          <ForgotPasswordForm buttonClassName="w-full bg-blue-600 text-white shadow-md transition-all duration-200 hover:bg-blue-700 hover:shadow-blue-600/25 rounded-xl border border-blue-700" />
        </div>

        <div className="mt-8 text-center">
          <Link
            href={signInUrl}
            className="inline-flex items-center justify-center text-sm font-semibold text-slate-500 transition-colors hover:text-blue-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 rounded-md"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            {backLinkText}
          </Link>
        </div>
      </div>
    </div>
  )
}
